import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import bodenImage from './FRONT IMAGES copy/FRONTCOVER_001 Large.jpeg';
import calliopeImage from './FRONT IMAGES copy/FRONTCOVER_004 Large.jpeg';
import weAreShoeImage from './FRONT IMAGES copy/FRONTCOVERWB_009 Large.jpeg';
import oakleyImage from './FRONT IMAGES copy/FRONTCOVER_010 Large.jpeg';
import numeroHImage from './FRONT IMAGES copy/FRONTCOVER_016 Large.jpeg';
import mBotturaImage from './FRONT IMAGES copy/Bottura front image Large.jpeg';
import miroWrenImage from './FRONT IMAGES copy/FRONTCOVERWB_005 Large.jpeg';
import behindTheBankImage from './FRONT IMAGES copy/FRONTCOVER_007 Large.jpeg';
import nFaceImage from './FRONT IMAGES copy/FRONTCOVER_015 Large.jpeg';
import image13 from './FRONT IMAGES copy/FRONTCOVER_013 Large.jpeg';
import thatchImage from './FRONT IMAGES copy/FRONTCOVERWB_014 Large.jpeg';
import scrimparelloImage from './FRONT IMAGES copy/FRONTCOVERWB_003 Large.jpeg';
import nfMinimeImage from './FRONT IMAGES copy/FRONTCOVER_006 Large.jpeg';
import vildImage from './FRONT IMAGES copy/FRONTCOVERWB_008 Large.jpeg';
import lozzaImage from './images/commercials/Lozza/LOZZAOCCHIALI_001 Large.jpeg';
import boboImage from './FRONT IMAGES copy/FRONTCOVERWB_011 Large.jpeg';
import uynImage from './images/commercials/UYN/UYN_FINAL_006 copy Medium.jpeg';
import calliopeKidsImage from './images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_001 copy Large.jpeg';
import cpCompanyCampaign from './images/commercials/CP Company Campaign/CPCOMPANY_FINAL001 copy Large.jpeg';
import milk from './images/commercials/AAA/TESTWITHULRIKE_001 Large.jpeg';
import bashImage from './images/commercials/BASH/23_BASH_01 Large.jpeg';
import scotiabankImage from './images/commercials/ScotiaBank/SCOTIA_BANK_001 Large.jpeg';
import CalliopeStudio from './images/commercials/CalliopeStudio/KIDS_BASIC_073 copy Large.jpeg';
import RubinGlasswork from './images/commercials/RubinGlasswork/RUBIN_GLASSWORK_FINAL_001.jpeg';
import ErnstingFamily from './images/commercials/ErnstingFamily/ERNSTINGFAMILY_000 Large.jpeg';
import CPCompanyTeensImage from './images/commercials/CP Company Teens/C.P. COMPANY_001 Large.jpeg';

const Commercials = () => {
    return (
        <>
        <Helmet>
            <title>Commercial Photography - Alessandro Iovino</title>
            <meta name="description" content="Explore commercial photography projects by Alessandro Iovino, featuring work with major brands like Boden, North Face, Oakley, and more." />
            <meta property="og:title" content="Commercial Photography - Alessandro Iovino" />
            <meta property="og:description" content="Professional commercial photography portfolio featuring work with leading global brands." />
            <link rel="canonical" href="https://alessandroiovino.com/commercials" />
        </Helmet>
        <div className="picture-gallery">
            <h1 className="sr-only">Commercial Photography</h1>
            <div className="commercial-grid">
                <div className="commercial-photo-column">
                   
                    <div className="commercial-item" id="uyn">
                        <Link to="/commercials/uyn-sports"><img src={uynImage} alt="UYN Sports commercial photography"/></Link>
                        <h2>UYN SPORTS</h2>
                    </div> 
                    <div className="commercial-item" id="miroWren">
                        <Link to="/commercials/miro-wren"><img src={miroWrenImage} alt="Miro & Wren commercial photography"/></Link>
                        <h2>MIRO & WREN</h2>
                    </div>
                    <div className="commercial-item" id="">
                        <Link to="/commercials/ernsting-family"><img src={ErnstingFamily} alt="Ernsting Family commercial photography"/></Link>
                        <h2>ERNSTING FAMILY</h2>
                    </div>
                    <div className="commercial-item" id="boden">
                        <Link to="/commercials/boden"><img src={bodenImage} alt="Boden commercial photography"/></Link>
                        <h2>BODEN</h2>
                    </div>
                    <div className="commercial-item" id="calliope">
                        <Link to="/commercials/calliope"><img src={calliopeImage} alt="Calliope commercial photography"/></Link>
                        <h2>CALLIOPE</h2>
                    </div>
                    <div className="commercial-item" id="we-are-shoe">
                    <Link to="/commercials/we-are-shoe"><img src={weAreShoeImage} alt="We Are Shoe commercial photography"/></Link>
                        <h2>WE ARE SHOE</h2>
                    </div>
                    <div className="commercial-item" id="bash">
                        <Link to="/commercials/bash"><img src={bashImage} alt="BASH commercial photography"/></Link>
                        <h2>BASH</h2>
                    </div>
                    <div className="commercial-item" id="oakley">
                        <Link to="/commercials/oakley"><img src={oakleyImage} alt="Oakley commercial photography"/></Link>
                        <h2>OAKLEY</h2>
                    </div>
                    <div className="commercial-item" id="thatch">
                        <Link to="/commercials/thatch"><img src={thatchImage} alt="Thatch commercial photography"/></Link>
                        <h2>THATCH</h2>
                    </div>     
                </div>

                <div className="commercial-photo-column">
                    <div className="commercial-item" id="CalliopeKids">
                        <Link to="/commercials/calliope-kids"><img src={calliopeKidsImage} alt="Calliope Kids commercial photography"/></Link>
                        <h2>CALLIOPE KIDS</h2>
                    </div> 
                    <div className="commercial-item" id="cpCompanyTeens">
                        <Link to="/commercials/cp-company-teens"><img src={CPCompanyTeensImage} alt="C.P. Company Teens commercial photography"/></Link>
                        <h2>C.P. COMPANY TEENS</h2>
                    </div> 
                    <div className="commercial-item" id="massimo-bottura">
                        <Link to="/commercials/m-le-monde-massimo-bottura"><img src={mBotturaImage} alt="M Le Monde Massimo Bottura commercial photography"/></Link>
                        <h2>M LE MONDE</h2>
                    </div>
                    <div className="commercial-item" id="newCommercial">
                        <Link to="/commercials/milk"><img src={milk} alt="Milk commercial photography"/></Link>
                        <h2>MILK</h2>
                    </div> 
                    <div className="commercial-item" id="behindthebank">
                        <Link to="/commercials/m-le-monde-behind-the-bank"><img src={behindTheBankImage} alt="M Le Monde Behind The Bank commercial photography"/></Link>
                        <h2>M LE MONDE</h2>
                    </div>
                    <div className="commercial-item" id="RubinGlasswork">
                        <Link to="/commercials/rubin-glasswork"><img src={RubinGlasswork} alt="Rubin Glasswork photography"/></Link>
                        <h2>RUBIN GLASSWORK</h2>
                    </div> 
                    <div className="commercial-item" id="scotiabank">
                        <Link to="/commercials/scotia-bank"><img src={scotiabankImage} alt="Scotia Bank commercial photography"/></Link>
                        <h2>SCOTIA BANK</h2>
                    </div>
                    <div className="commercial-item" id="NF">
                        <Link to="/commercials/the-north-face"><img src={nFaceImage} alt="The North Face commercial photography"/></Link>
                        <h2>THE NORTH FACE</h2>
                    </div>
                    
                </div>

                <div className="commercial-photo-column">
                     <div className="commercial-item" id="CPCompanyCampaign">
                        <Link to="/commercials/cp-company-ss026-kids-campaign"><img src={cpCompanyCampaign} alt="CP Company SS026 Kids Campaign"/></Link>
                        <h2>CP COMPANY SS026 KIDS CAMPAIGN</h2>
                    </div> 
                    <div className="commercial-item" id="CalliopeStudio">
                        <Link to="/commercials/calliope-studio"><img src={CalliopeStudio} alt="Calliope Studio commercial photography campaign"/></Link>
                        <h2>CALLIOPE STUDIO</h2>
                    </div>
                    <div className="commercial-item" id="scimparello">
                        <Link to="/commercials/scimparello-magazine"><img src={scrimparelloImage} alt="Scimparello Magazine commercial photography"/></Link>
                        <h2>SCIMPARELLO MAGAZINE</h2>
                    </div>
                    <div className="commercial-item" id="NF-minime">
                        <Link to="/commercials/the-north-face-mini-me"><img src={nfMinimeImage} alt="The North Face Mini Me"/></Link>
                        <h2>THE NORTH FACE</h2>
                    </div>
                    <div className="commercial-item" id="house-of-V">
                        <Link to="/commercials/house-of-vild"><img src={vildImage} alt="House of Vild commercial photography"/></Link>
                        <h2>HOUSE OF VILD</h2>
                    </div>
                    <div className="commercial-item" id="lozza-occhiali">
                        <Link to="/commercials/lozza-occhiali"><img src={lozzaImage} alt="Lozza Occhiali commercial photography"/></Link>
                        <h2>LOZZA OCCHIALI</h2>
                    </div>
                    <div className="commercial-item" id="numero-homme">
                        <Link to="/commercials/numero-homme"><img src={numeroHImage} alt="Numero Homme commercial photography"/></Link>
                        <h2>NUMERO HOMME</h2>
                    </div>
                    <div className="commercial-item" id="bobo">
                        <Link to="/commercials/bobo"><img src={boboImage} alt="Bobo commercial photography"/></Link>
                        <h2>BOBO</h2>
                    </div>
                    <div className="commercial-item" id="13">
                        <Link to="/commercials/librino-biennale"><img src={image13} alt="Librino Biennale commercial photography"/></Link>
                        <h2>LIBRINO BIENNALE</h2>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Commercials;